import { jsx as o } from "react/jsx-runtime";
import { Form as i, Formik as n } from "formik";
import p from "styled-components";
const e = p(i)`
  padding: ${(r) => r.$formPadding || "32px"};
`, c = (r) => {
  const { children: d, formPadding: m, ...t } = r;
  return /* @__PURE__ */ o(n, { ...t, children: /* @__PURE__ */ o(e, { $formPadding: m, children: d }) });
};
export {
  c as Wrapper,
  c as default
};
